import styled from "styled-components";
import {
  NavigationContextSwitcher,
  DropdownButton,
  HeaderContextMenuContent,
} from "@cdkglobal/radial";

export const StyledContextSwitcherContainer = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[200].value};
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding-bottom: ${({ theme }) => theme.size.spacing.small.value};
  padding-top: ${({ theme }) => theme.size.spacing.small.value};
`;

export const StyledDropdownButton = styled(DropdownButton)`
  background-color: ${({ theme }) => theme.color.gray[200].value} !important;
  margin: -2.5px 8px;

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[300].value} !important;
  }
`;

export const StyledUserContextMenu = styled(HeaderContextMenuContent)<{
  $hideSignOut?: boolean;
}>`
  z-index: 1000;
  position: absolute;

  button {
    width: auto !important;
    margin-bottom: 0.5rem;
  }

  ${({ $hideSignOut }) =>
    $hideSignOut &&
    `
      button:last-child {
        display: none !important;
      }
    `}
`;

export const StyledNavigationContextSwitcher = styled(
  NavigationContextSwitcher,
).attrs({
  className: "nav-context-switcher",
})`
  .nav-context-switcher-button *,
  .nav-context-switcher-button svg {
    color: black !important;
    fill: black;
  }

  background-color: ${({ theme }) => theme.color.gray[200].value} !important;
  border-radius: 8px;
  margin: 3px 1px;
  align-self: center;

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[200].value} !important;
  }
`;
